import React from "react";
import { cn } from "./cn";

/**
 * Bun household header: avatar cluster + name + status + meta on the left,
 * actions on the right. Spec: Household Overview canvas. Sits under a
 * Breadcrumbs row and above Tabs; both compose around it.
 *
 *   <HouseholdHeader
 *     avatars={<AvatarGroup><Avatar size="lg" overlap name="Maya Patel" />...</AvatarGroup>}
 *     title="Maya & Dev Patel"
 *     badge={<Badge tone="success">Active</Badge>}
 *     meta="Illinois"
 *   >
 *     <Toggle label="Meeting mode" ... />
 *     <Button variant="secondary">RC export</Button>
 *     <Button>Log follow-up</Button>
 *   </HouseholdHeader>
 */
export default function HouseholdHeader({ avatars, title, badge, meta, className, children }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-[14px] font-instrument sm:flex-nowrap", className)}>
      {avatars && <div className="shrink-0">{avatars}</div>}
      <div className="min-w-0 flex-1 sm:contents">
        <h1 className="m-0 break-words font-instrument text-bun-number font-semibold leading-tight tracking-[-0.008em] text-bun-text sm:truncate sm:text-bun-display">
          {title}
        </h1>
        {(badge || meta) && <div className="mt-1 flex flex-wrap items-center gap-2 sm:contents">
          {badge}
          {meta && <span className="text-bun-meta font-book text-bun-stone whitespace-nowrap">{meta}</span>}
        </div>}
      </div>
      <div className="hidden sm:block sm:flex-1" />
      {children && <div className="flex w-full flex-wrap items-center gap-[10px] sm:w-auto">{children}</div>}
    </div>
  );
}
